export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL || (
    process.env.NODE_ENV === 'production' ? window.location.origin : API_URL
);
